import React from 'react'
import { useHelpContext } from './hooks'
import TopicOverviewPage from './TopicOverviewPage'
import HomePage from './HomePage'
import ArticlePage from './ArticlePage'
import MoreHelpPage from './MoreHelpPage'
import ContactPage from './ContactPage'
import TourPage from './TourPage'
import Search from './Search'
import SupportPage from './SupportPage'

const routes = {
  topic: TopicOverviewPage,
  article: ArticlePage,
  home: HomePage,
  moreHelp: MoreHelpPage,
  contact: ContactPage,
  tour: TourPage,
  support: SupportPage
}

export default function Router() {
  const {
    navigation,
    navigation: {
      activePage: { path, parameters }
    }
  } = useHelpContext()

  const Page = routes[path]

  return (
    <div data-testid="uhqm-router-container">
      <Search>
        <Page parameters={parameters} navigation={navigation} />
      </Search>
    </div>
  )
}
